export default "__VITE_ASSET__d3fb5c62__"